module.exports = __webpack_public_path__ + "img/ax.c058a3c3.svg";